import React, { useEffect } from "react";
import { LoadingIndicator } from "elements";
import { useHistory, useRouteMatch } from "polyrouter";
import { useTranslation } from "utilities/i18n";
import {
  useAccessorQuery,
  UserFragmentFragment,
  useUserByIdQuery
} from "generated/graphql";
import { MemberDetailsCard } from "./MemberDetailsCard";
import "./MemberDetails.scss";
import { Layout } from "views/Main/Layouts";
import { generatePath } from "react-router";

export type MemberDetailsProps = UserFragmentFragment;

export const MemberDetails: React.FC = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<{
    user_id: string;
    id: string;
  }>();
  const id: string = match.params.user_id;
  const tid = match.params.id;
  const history = useHistory();

  const { Sidebar, Content } = Layout;
  const { data: userData, fetching: userFetching } = useUserByIdQuery({
    variables: {
      id
    }
  });
  const { data: accessorData, fetching: accessorFetching } = useAccessorQuery({
    variables: {
      accessorId: id
    }
  });

  const fetching = userFetching || accessorFetching;

  useEffect(() => {
    if (!fetching) {
      if (!userData?.user?.user) {
        history.push(generatePath(`/admin/accounts/details/${tid}/members`));
      } else if (
        tid &&
        !accessorData?.accessor?.grants?.filter(
          grant => grant.resourceId === tid
        )[0]
      ) {
        history.push(generatePath(`/admin/accounts/details/${tid}/members`));
      }
    }
  }, [fetching, tid, userData, accessorData, history]);

  if (fetching) {
    return <LoadingIndicator />;
  }

  const user = userData?.user?.user;

  return (
    <>
      {user ? (
        <>
          <Sidebar>
            {user?.picture ? (
              <img src={user.picture} alt="" className="avatar" />
            ) : (
              ""
            )}
          </Sidebar>
          <Content scrolling details>
            <Content.ScrollingList>
              <MemberDetailsCard title={t("MEMBER_DETAILS")} {...user} />
            </Content.ScrollingList>
          </Content>
        </>
      ) : null}
    </>
  );
};

export default MemberDetails;
